var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",style:(`background: ${_vm.template.color}; color: ${_vm.template.textColor || '#fff'};`)},[_c('Logos',{attrs:{"template":_vm.template}}),_c('dir',{class:['text', _vm.textClose],domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }